const validateSelects = (value: unknown[]) => {
    if (value.length === 0) {
        return {
            isValid: false,
            message: "Veuillez sélectionner une valeur",
        };
    } else
        return {
            isValid: true,
            message: "",
        };
};

export default validateSelects;
